import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearToast as clearToastAction } from '../../../actions/toast-actions';
import FloatingAlert from '../FloatingAlert';

const GlobalToast = () => {
  const dispatch = useDispatch();
  const { message } = useSelector(({ toast }) => toast);
  const clearToast = useCallback(() => dispatch(clearToastAction()), [
    dispatch,
  ]);

  return (
    <FloatingAlert
      message={message}
      timeout={2500}
      dismissible
      onDismiss={() => clearToast()}
    />
  );
};

export default GlobalToast;
